import { useEffect } from 'react';
import { BrandLoader } from '@acs/ui';
import { holdBootLoader } from './bootLoader.js';

/**
 * Whole-screen loading state for route gates and pages still fetching their
 * subject. On a fresh load it sits under the boot loader and keeps it up; after
 * that it fades in late (`.page-loader`), so a fast load never flashes it.
 */
export function PageLoader() {
  useEffect(() => holdBootLoader(), []);
  return (
    <div className="center-screen page-loader">
      <BrandLoader size={48} />
    </div>
  );
}
